var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Component_58_115",
    "data-name": "Component 58 \\u2013 115",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_57_2",
    "data-name": "Component 57 \\u2013 2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3683",
    "data-name": "Rectangle 3683",
    width: 32,
    height: 32,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11418",
    "data-name": "Group 11418",
    transform: "translate(-1215 -111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_402",
    "data-name": "Ellipse 402",
    transform: "translate(1224 120)",
    fill: "none",
    stroke: "#264ae4",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11969",
    "data-name": "Path 11969",
    d: "M-573.727,16257.489l5.06,5.06",
    transform: "translate(1807 -16128)",
    fill: "none",
    stroke: "#264ae4",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.8fa246414a4c0ca757ddc51ba1e1e42b.svg";
export { ForwardRef as ReactComponent };